export enum CompanyWeightingType {
    Owner = 1,
    Charterer = 2,
    Broker = 3,
    Buyer = 4,
    Operator = 5,
}
